module.exports = __webpack_public_path__ + "static/media/kiss.c77393b6.svg";